import { MonitoringContext, MonitoringMessageOptions, MonitoringModule } from './monitoring.interface';

export interface SentryMonitoringDeps {
  init: () => void;
  captureException: (error: unknown) => void;
  captureMessage: (message: string, options: MonitoringMessageOptions) => void;
  addBreadcrumb: (name: string, context?: MonitoringContext) => void;
}

export const createSentryMonitoring = (deps: SentryMonitoringDeps): MonitoringModule => ({
  init: (): void => deps.init(),
  captureException: (error: unknown): void => deps.captureException(error),
  captureMessage: (message: string, options: MonitoringMessageOptions): void => deps.captureMessage(message, options),
  action: (name: string, context?: MonitoringContext): void => deps.addBreadcrumb(name, context),
});
